import resize from "../resize";
import IMask from "imask";
import vanillaToast from "vanilla-toast";
import axios from "axios";
import metrics from "../metrics";
import {modal} from '../modal/init-modal';
import { Category, EmploymentFormat, Education } from './constants';

const form = () => {
  const citizenRequest= "https://hermes.smile-tech.study/api/v1/lead?programId=";
  const FlowCRM = "https://2025.api.tgu-dpo.ru/citizenrequest/InternalNewRequest",
  AMO = "https://hook.eu2.make.com/fkxwiz61almfr7wcwvw3bxrxye9za18w";

  // Список программ для отправки в АМО 
  const AmoPrograms = [
    "data-analysis-low-code",
    "prompt-engineering",
    "itprojectmanagement",
    "2line-tech-support",
    "1line-tech-support"
  ]

  /* Замена текста в зависимости от ширины экрана */
  function resizeForm() {
    const text = document.querySelector(".form__info-change");

    if (!text) {
      return;
    }

    if (innerWidth > 996) {
      text.innerHTML = "справа";
    } else {
      text.innerHTML = "снизу";
    }
  }

  const invalidCharsRegex = /[^a-zA-Z0-9.@_-]/; // Разрешённые символы

  $('[type=email]').on('input', function() {
      const inputValue = $(this).val();

      // Проверяем наличие недопустимых символов
      const invalidChars = inputValue.match(invalidCharsRegex);
      const input = $(this).get(0);
      const inputParent = $(this).parent().get(0);

      if (input.classList.contains('form-invalid')) {
        input.classList.remove('form-invalid');
        inputParent.querySelector('.form-error')?.remove();
      }
      const error = {};

      if (invalidChars) {
        error.message = `Недопустимый символ: "${invalidChars[0]}"`;
        input.classList.add('form-invalid');

        showError(error, inputParent)
      }
  });

  // Подсказки для ввода почты
  const validDomains = ['yandex.ru', 'mail.ru', 'gmail.com', 'hotmail.com', 'outlook.com'];

  $('[type=email]').on('input', function() {
    const emailInput = $(this);
    const emailValue = emailInput.val();
    const suggestionsDiv = emailInput.siblings('.suggestions');

    const atIndex = emailValue.indexOf('@');
    if (atIndex !== -1) {
        const domainPart = emailValue.slice(atIndex + 1);
        const suggestions = validDomains.filter(domain => domain.startsWith(domainPart));
        suggestionsDiv.empty(); // Очистка предыдущих подсказок

        if (suggestions.length > 0) {
            suggestions.forEach(domain => {
                suggestionsDiv.append(`<span class="suggestion-item">${emailValue.slice(0, atIndex + 1)}${domain}</span>`);
            });
            suggestionsDiv.show();
        } else {
            suggestionsDiv.hide();
        }
    } else {
        suggestionsDiv.hide();
    }
  });

  // Обработчик клика на предложениях
  $(document).on('click', '.suggestion-item', function() {
      const emailInput = $(this).closest('form').find('[type=email]');
      emailInput.val($(this).text()).focus();
      emailInput.siblings('.suggestions').hide();
  });

  /* Валидаторы */
  const validators = {
    requried: function (value, error) {
      if (!value || value.length === 0) {
        error.message = "Это поле обязательно";
        return false;
      } else {
        return true;
      }
    },
    phone: function (value, error) {
      if (/^((\+7|7|8)\s?\(?(\d{3})\)?[\s-]?(\d{3})[\s-]?(\d{2})[\s-]?(\d{2}))$/.test(value)) {
        return true;
      } else {
        error.message = "Некорректный номер телефона";
        return false;
      }
    },
    email: function (value, error) {
      if (/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)) {
        return true;
      } else {
        error.message = "Некорректный email";
        return false;
      }
    },
    birthday: function (value, error) {
      var parts = value.split(".");
      if (
        parts.length != 3 ||
        parts[0].length != 2 ||
        parts[1].length != 2 ||
        parts[2].length != 4
      ) {
        error.message = "Некорректная дата рождения";
        return false;
      }

      return true;
    },
  };

  /* Добавление ошибок валидации */
  function showError(error, field) {
    if (error.message) {
      var errorContainer = document.createElement("div");
      errorContainer.textContent = error.message;
      errorContainer.classList.add("form-error");
      field.appendChild(errorContainer);
    }
  }

  /* Удаление ошибок валидации */
  function deleteErrors(form) {
    form.querySelectorAll(".form-error").forEach(function (el) {
      el.remove();
    });
    form.querySelectorAll(".form-invalid").forEach(function (el) {
      el.classList.remove("form-invalid");
    });
  }

  /* Валидация формы */
  function validate(form) {
    let result = true;

    Array.from(form.querySelectorAll(".form__field")).forEach(function (
      formField
    ) {
      let error = {},
        control = formField.querySelector("select, input, textarea");

      if (formField.querySelector(".form-required")) {
        if (!validators.requried(control.value, error)) {
          showError(error, formField);
          control.classList.add("form-invalid");
          result = false;
          return;
        }
      }

      if (control.type === "tel") {
        if (!validators.phone(control.value, error)) {
          showError(error, formField);
          control.classList.add("form-invalid");
          result = false;
        }
      }

      if (control.type === "email") {
        if (!validators.email(control.value, error)) {
          showError(error, formField);
          control.classList.add("form-invalid");
          result = false;
        }
      }

      if (control.id === "birthday") {
        if (!validators.birthday(control.value, error)) {
          showError(error, formField);
          control.classList.add("form-invalid");
          result = false;
        }
      }
    });

    let invalidField = form.querySelector(".form-invalid");
    if (invalidField) {
      invalidField.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }

    return result;
  }

  /* Получения cookie */
  function getCookie(cname) {
    let name = cname + "=",
      decodedCookie = decodeURIComponent(document.cookie),
      ca = decodedCookie.split(";");

    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];

      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }

      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }

    return "";
  }

  /* Проверка ИНН */
  function validateInn(INN) {
    var result = false;
    let inn = +INN;
    
    if (typeof inn === 'number') {
      inn = inn.toString();
    } else if (typeof inn !== 'string') {
      inn = '';
    }

    if (!inn.length) {
      result = false;
    } else if (/[^0-9]/.test(inn)) {
      result = false;      
    } else if ([10].indexOf(inn.length) === -1) {
      result = false;      
    } else {
      result = true;    
    }

    return result;
  }

  /* Валидация промокода */
  function validatePromocode(INN) {
    let inn = INN.trim();
    
    if (!inn.length) {
      return false;
    } else if (/[a-zA-Z]/.test(inn)) {
      return false;      
    } else if ((inn.length < 4 || inn.length > 10)) {
      return false;      
    } else {      
      return true;    
    }
  }

  /* Отправка формы */
  async function send(form, e, modalData, quiz = false) {
    let sendBtn = form.querySelector(
        'button[type="submit"], input[type="submit"]'
      ),
      data = {};

    if (modalData) {
      data = { ...modalData };      
    } else {
      e.preventDefault();
      deleteErrors(form);

      data = {};

      if (!validate(form)) {
        return;
      }
      
      Array.from(new FormData(form)).forEach(function (formElement) {
        let key = formElement[0],
          value = formElement[1];

        if (key == "BirthDate") {
          data[key] = value.split(".").reverse().join("-");
        } else if (key == "Region") {
          data[key] = returnRegionName("#Regions option", value);
          data["RegionId"] = value;
        } else if (key == "ParticipantNumber") {          
          if (validatePromocode(value)) {
            data["ParticipantNumber"] = value.toUpperCase();
          } else {
            data["ParticipantNumber"] = "";
          }
        } else if (key == "ParticipationSZ"){
          if (value == "true"){
            data["ParticipationSZ"] = true;
          }
          else{
            data["ParticipationSZ"] = false;
          }
        } else if (key == 'category') {
          data[key] = Category[value] ? Category[value] : value;
        } else if (key == 'EmploymentFormat') {
          data[key] = EmploymentFormat[value] ? EmploymentFormat[value] : value;
        } else if (key == 'Education') {
          data[key] = Education[value] ? Education[value] : value;
        } else {
          data[key] = value;
        }
      });
    }    

    sendBtn.disabled = true;

    let url = document.location.href,
      paramsStartIndex = url.indexOf("?");

    try {
      if (paramsStartIndex > -1) {
        url
          .slice(paramsStartIndex + 1, url.length)
          .split("&")
          .map(function (utmString) {
            return utmString.split("=");
          })
          .forEach(function (utmMark) {
            var key = utmMark[0];
            key = key[0].toUpperCase() + key.slice(1, key.length);
            var value = utmMark[1];
            value =
              value.indexOf("#") > -1
                ? value.slice(0, value.indexOf("#"))
                : value;
            data[key] = value;
          });
      }
    } catch(e) {
      console.log(e);      
    }

    data["Landing"] = url.split("?")[0] || url;
    
    /* Добавление данных в передачу формы */
    const programList = document.querySelector("#Program")?.children,
      programHidden = form.querySelector(".program-hidden");

    if (!quiz) {
      if (programList && !programHidden) {
        [...programList].forEach((item) => {
          if (data["Program"] == item.value) {
            if (item.getAttribute("operator")) {
              data["Operator"] = item.getAttribute("operator");
            }

            if (item.getAttribute("shortname")) {
              data["shortname"] = item.getAttribute("shortname");
            }
  
            if (item.getAttribute("program_id")) {
              if (item.getAttribute("program_id") == "null" || item.getAttribute("program_id") == null) {
                data["program_id"] = null;
              } else {
                data["program_id"] = Number(item.getAttribute("program_id"));
              }
            }
  
            if (item.getAttribute("linkrvr")) {
              data["rvr_link"] = item.getAttribute("linkrvr");
            }
          }
        });
      } else {
        if (programHidden.getAttribute("operator")) {
          data["Operator"] = programHidden.getAttribute("operator");
        }

        if (programHidden.getAttribute("shortname")) {
          data["shortname"] = programHidden.getAttribute("shortname");
        }

        if (programHidden.getAttribute("program_id")) {
          if (programHidden.getAttribute("program_id") == "null" || programHidden.getAttribute("program_id") == null) {
            data["program_id"] = null;
          } else {
            data["program_id"] = Number(programHidden.getAttribute("program_id"));
          }
        }
  
        if (programHidden.getAttribute("linkrvr")) {
          data["rvr_link"] = programHidden.getAttribute("linkrvr");
        }
      }
    }

    let ym_uid = getCookie("_ym_uid");
    if (ym_uid) {
      data["client_id"] = ym_uid;
    }

    /* Ройстат */
    let roistatCookie = getCookie("roistat_visit");

    if (!!roistatCookie) {
      data["roistat"] = roistatCookie;
    }

    /* AdvCake cookie берем до удаления cookie */
    let advcakeCookie = getCookie("advcake_track_id");
    
    axios
      .post(citizenRequest + data["program_id"], data)
      .then(function (result) {
        sendBtn.disabled = false;

        // В зависимости от программ отправляем в разные места
        try {
          if (AmoPrograms.includes(data.shortname)) {
            formSubmitAMO(data);
          } else {
            formSubmitFlow(data);
          }
        } catch(e) {
          console.log(e);          
        }

        if (form.id == "quiz-form") {
          ym(94760218, "reachGoal", "qwiz_submit_form");
          setTimeout(() => {
            const newTab = window.open("https://t.me/TGUinfoBot", "_blank");
            if (newTab) {
              newTab.focus();
            } else {
              window.location.assign("https://t.me/TGUinfoBot");
            }
          }, 0);          
        } else {
          onSuccess(data);
        }

        /* Метрики */
        fbq("track", "Lead");
        ym(94760218, "reachGoal", "submit_form");
        ym(94760218,'reachGoal','FormSubmitOnline');
        var _tmr = window._tmr || (window._tmr = []);
        _tmr.push({ id: "3244339", type: "reachGoal", goal: "lead" });
        _tmr.push({ type: 'reachGoal', id: 3413771, goal: 'lead'});

        try {
          VK.Goal("lead");
          VK.Retargeting.Event("lead");
        } catch {}

        if (data["EmploymentFormat"] === "2") {
          ym(94760218,'reachGoal','submit_form_trud');
          _tmr.push({ type: 'reachGoal', id: 3413771, goal: 'lead_trud'});
        }

        addAdvCakeScript(
          result.data.requestId,
          result.data.programName,
          data.email,
          advcakeCookie
        );

        form.reset();
        $('#Category').val('').trigger('change');
        $('#Education').val('').trigger('change');
        $('#EmploymentFormat').val('').trigger('change');
        $('#Regions').val('').trigger('change');
        $('#Program').val('').trigger('change');
      })
      .catch(function (error) {
        console.log(error);
        sendBtn.disabled = false;
        vanillaToast.error(
          "Пожалуйста, проверьте ваше соединение с сетью или повторите попытку позже",
          { duration: 3000, fadeDuration: 500 }
        );
      });
  }

  /* Отправка формы в АМО */
  function formSubmitAMO(data) {
    axios
      .post(AMO, data)
  }

  /* Отправка формы во Flow */
  function formSubmitFlow(data) {
    data['FirstName'] = data['name'];
    data['Phone'] = data['phone'];
    data['Email'] = data['email'];
    data['LastName'] = '-';
    data["category"] = getKeyByValue(Category, data["category"]);
    data["EmploymentFormat"] = getKeyByValue(EmploymentFormat, data["EmploymentFormat"]);
    data["Education"] = getKeyByValue(Education, data["Education"]);

    axios
      .post(FlowCRM, data)
  }

  /* Полчуние ключа объекта */
  function getKeyByValue(object, value) {
    return Object.keys(object).find(key => object[key] === value);
  } 

  /* Установка форм */
  function setForm(selector) {
    var form = document.querySelector(selector);

    if (!form) {
      return;
    }

    form.addEventListener("submit", function (e) {
      send(form, e);
    });

    onFormFilling(form, () => {
      ym(94760218, "reachGoal", "FormStart");
      ym(94760218,'reachGoal','FormStartOnline');
      fbq("track", "InitiateCheckout");
      VK.Retargeting.Event('Initiate_Checkout');
    });
  }

  /* Блокировка кнопки отправки формы */
  function setFormCheckbox(arr, btn) {
    try {
      arr.forEach((item) => {
        item.addEventListener("change", function () {
          if (!arr.find((checkbox) => !checkbox.checked)) {
            btn.removeAttribute("disabled");
          } else {
            btn.setAttribute("disabled", "disabled");
          }
        });
      });
    } catch (e) {}
  }

  /* Функция успешной отправки формы */
  function onSuccess(data = null) {
    if (data !== null) {
      if (data.rvr_link && data.rvr_link !== "undefined") {
        let urlRvR = data.rvr_link;
        /* FLOW-12326 */
        // successRedirectModal(urlRvR, data["Operator"]);

        setTimeout(() => {
          const newTab = window.open(urlRvR, "_blank");
          if (newTab) {
            newTab.focus();
          } else {
            window.location.assign(urlRvR);
          }
          ym(94760218,'reachGoal','click_RR');
          ym(94760218,'reachGoal','wait_redirect');
        }, 0);
      } else {
        successModal();
      }
    }
  }

  /* Модальное окно после отправки формы с редиректом */
  function successRedirectModal(urlRvR, operator) {
    let Modal = document.querySelector(".success__modal");
    /* Добавляем ссылку на скачивание инструкции */
    // const downloadInstruction = document.createElement("a");
    // downloadInstruction.setAttribute("download", "");
    // downloadInstruction.style.display = "none";
    // document.body.append(downloadInstruction);    
    // downloadInstruction.href = INSTRUCTION;
    // downloadInstruction.click();

    /* Добавляем ссылку на скачивание лида */
      // const downloadLead = document.createElement("a");
      // downloadLead.href =
      //   "/files/documents/Otvety_na_to_kak_vyyti_na_dokhod_ot_70_000_rubley_new.pdf";
      // downloadLead.setAttribute("download", "");
      // downloadLead.style.display = "none";
      // document.body.append(downloadLead);
      // downloadLead.click();

    if (!Modal) {
      Modal = document.createElement("div");
      Modal.classList.add("success__modal", "custom-modal__hidden");
      Modal.id = "success__modal";
      document.body.append(Modal);
    }

    Modal.innerHTML = `
      <div class="success__modal-content">
        <h4>Поздравляем с&nbsp;успешной регистрацией!</h4>
        <p>Далее вам необходимо подтвердить заявку на&nbsp;портале «Работа в&nbsp;России» в&nbsp;течение 3&nbsp;дней.</p>
        <p class="сountdown">
            Через <strong><span class="timer">15</span> секунд</strong> вы будете автоматически перенаправлены на&nbsp;портал <a class="success__modal-link timer" href="${urlRvR}" onclick="ym(94760218,'reachGoal','click_RR')" target="_blank">«Работа России»</a>
        </p>
        <p><b>Это обязательное условие для участия в&nbsp;проекте «Активные меры содействия занятости».</b></p>
        <p>На&nbsp;указанную почту мы&nbsp;отправили <span class="note">подробные инструкции</span> и&nbsp;ссылку на&nbsp;<span class="note">вступление в&nbsp;чат</span> программы.</p>
        <p>С&nbsp;их&nbsp;помощью вы&nbsp;сможете пройти все шаги и&nbsp;подписать договор о&nbsp;намерениях от&nbsp;работодателя.</p>
        <p><b>Не&nbsp;забывайте проверять папку &laquo;Спам&raquo;.</b></p>                        
      </div>
      <div class="success__modal-image">
        <img src="/img/components/modal/letter.webp" alt="Картинка с письмом">
      </div>
    `;

    setTimerRedirect(Modal.querySelector(".timer"));
    modal.openModal('success__modal');
    document.querySelector(".custom-modal-close").style.display = "none";
    document.querySelector(".custom-modal__overlay").style.pointerEvents =
      "none";

    /* Запуск метрики для кнопки телеграм в модальных окнах */
    metrics();
  }

  /* Модальное окно после отправки формы */
  function successModal() {
    /* Добавляем ссылку на скачивание лида */
    // const downloadLead = document.createElement("a");
    // downloadLead.href = "/files/documents/Otvety_na_to_kak_vyyti_na_dokhod_ot_70_000_rubley_new.pdf";
    // downloadLead.setAttribute("download", "");
    // downloadLead.style.display = "none";
    // document.body.append(downloadLead);
    // downloadLead.click();

    let Modal = document.querySelector(".success__modal");

    if (!Modal) {
      Modal = document.createElement("div");
      Modal.classList.add("success__modal", "custom-modal__hidden");
      Modal.id = "success__modal";
      document.body.append(Modal);
    }

    Modal.innerHTML = /*html*/ `
      <div class="success__modal-content">
        <h4>Благодарим за заявку!</h4>
        <p>Ваша заявка попала в&nbsp;список приоритетных кандидатов.</p>
        <p>На&nbsp;указанную почту мы&nbsp;отправили <span class="note">подробные инструкции</span>. С&nbsp;их&nbsp;помощью вы&nbsp;сможете пройти все шаги и&nbsp;подписать договор о&nbsp;намерениях от&nbsp;работодателя.</p>
        <p><b>Не&nbsp;забывайте проверять папку &laquo;Спам&raquo;.</b></p>                        
      </div>
      <div class="success__modal-image">
        <img src="/img/components/modal/letter.webp" loading="lazy" alt="Картинка с письмом">
      </div>
    `;
    
    modal.openModal('success__modal');

    /* Запуск метрики для кнопки телеграм в модальных окнах */
    metrics();
  }

  /* Таймер редиректа */
  function setTimerRedirect(el) {
    if (!el) {
      console.error("Не передан элемент");
      return;
    }
    const interval = setInterval(() => {
      if (el.textContent === "0" || Number(el.textContent) < 1) {
        clearInterval(interval);
        return;
      }
      el.textContent = Number(el.textContent) - 1;
    }, 1000);
  }

  /* Начало заполнения формы */
  function onFormFilling(form, callback) {
    const controls = form.querySelectorAll("input, select, textarea");
    let changed = false;
    controls.forEach((control) => {
      $(control).one("blur", (e) => {
        if (!changed) {
          callback(e);
          changed = true;
        }
      });
    });
  }

  /* Вызов функций */
  let phoneInput = document.getElementById("phone");
  let phoneModalInput = document.getElementById("phone-modal");

  if (phoneInput) {
    new IMask(phoneInput, {
      mask: "+{7} (000) 000-00-00",
    });
  }

  if (phoneModalInput) {
    new IMask(phoneModalInput, {
      mask: "+{7} (000) 000-00-00",
    });
  }

  /* Возвращает название региона для отправки формы */
  function returnRegionName(id, region) {
    let regionList = document.querySelectorAll(id);

    for (let i = 0; i < regionList.length; i++) {
      if (region == regionList[i].value) {
        return regionList[i].textContent;
      }
    }
  }

  /* Возвращает название региона для отправки формы в квизе */
  function returnRegionNameInQuiz(id, region) {
    let regionList = document.querySelectorAll(id);

    for (let i = 0; i < regionList.length; i++) {
      if (region == regionList[i].value) {
        return regionList[i].id;
      }
    }
  }

  /* Переключение и отправка формы в Квизе */
  function quizForm() {
    const slides = document.querySelectorAll(".quiz__slide"),
      submit = document.getElementById("quiz-btn");

    if (slides.length < 1) {
      return;
    }

    submit.addEventListener("click", (e) => {
      let target = e.target,
        form = target.closest(".quiz__slide-form");

      e.preventDefault();
      deleteErrors(form);

      if (validate(form)) {
        send(form, e, getFormModalData(), true);
      }
    });
  }

  /* Получение данных с форм в модальных окнах */
  function getFormModalData() {
    const forms = document.querySelectorAll(".quiz__slide-form");

    let data = {};
    [...forms].forEach((form) => {
      Array.from(new FormData(form)).forEach(function (formElement) {
        let key = formElement[0];
        let value = formElement[1];
        
        if (key == "Program") {
          const Program = document.querySelector("input[name='Program']:checked");
          data[key] = value;
          
          if (Program) {
            if (Program.getAttribute("operator")) {
              data["Operator"] = Program.getAttribute("operator");
            }

            if (Program.getAttribute("shortname")) {
              data["shortname"] = Program.getAttribute("shortname");
            }

            if (Program.getAttribute("program_id")) {
              if (Program.getAttribute("program_id") == "null" || Program.getAttribute("program_id") == null) {
                data["program_id"] = null;
              } else {
                data["program_id"] = Number(Program.getAttribute("program_id"));
              }
            }
      
            if (Program.getAttribute("linkrvr")) {
              data["rvr_link"] = Program.getAttribute("linkrvr");
            }
          }
        } else if (key == "BirthDate") {
          data[key] = value.split(".").reverse().join("-");
        } else if (key == "Region") {
          data[key] = value;
          data["RegionId"] = returnRegionNameInQuiz("input[name=Region]", value);
        } else if (key == "ParticipantNumber") {
          if (validatePromocode(value)) {
            data["ParticipantNumber"] = value.toUpperCase();
          } else {
            data["ParticipantNumber"] = "";
          }
        } else if (key == "ParticipationSZ"){
          if (value == "true"){
            data["ParticipationSZ"] = true;
          }
          else{
            data["ParticipationSZ"] = false;
          }
        } else if (key == 'category') {
          data[key] = Category[value] ? Category[value] : value;
        } else if (key == 'EmploymentFormat') {
          data[key] = EmploymentFormat[value] ? EmploymentFormat[value] : value;
        } else if (key == 'Education') {
          data[key] = Education[value] ? Education[value] : value;
        } else {
          data[key] = value;
        }
      });

      form.reset();
    });

    return data;
  }

  /* Инициализация функций */
  setForm("#form-app");
  setForm("#modal-main");
  quizForm();
  setFormCheckbox(
    [
      document.querySelector("#form-check"),
      document.querySelector("#form-check--pd"),
    ],
    document.querySelector("#form-btn")
  );
  setFormCheckbox(
    [
      document.querySelector("#form-check-quiz"),
      document.querySelector("#form-check-quiz--pd"),
    ],
    document.querySelector("#quiz-btn")
  );
  setFormCheckbox(
    [
      document.querySelector("#form-check-modal"),
      document.querySelector("#form-check-modal--pd"),
    ],
    document.querySelector("#form-btn-modal")
  );
  resize(resizeForm);
  resizeForm();

  /* Пользователь находится на сайте больше 30 сек  */
  setTimeout(() => {
    VK.Retargeting.Event("PageView30sec");
    fbq("track", "PageView30s");
  }, 30000);

  /* Добавление скрипта AdvCake на сайт */
  function addAdvCakeScript(id, program, email, advcakeCookie) {
    const pageUrl = document.location.href;

    window.advcake_data = window.advcake_data || [];
    window.advcake_data.push({
      pageType: 6,
      user: {
        email: `md5(${email})`,
        type: "",
      },
      leadInfo: {
        id: `${id}`,
        name: `${program}`,
        totalPrice: 0,
        coupon: "",
        marketing_cat: 1,
        trackId: `${advcakeCookie}`,
        url: `${pageUrl}`,
      },
    });
  }
};

export default form;
